// ===== ALL API CALLS ARE RELATIVE (proxied by vue.config.js) =====

export async function listDevices(params = {}) {
  const query = new URLSearchParams(params).toString()
  const res = await fetch(`/api/devices?${query}`)
  if (!res.ok) throw new Error('Failed to fetch devices')
  return res.json()
}

export async function createDevice(device) {
  const res = await fetch('/api/devices', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(device)
  })
  if (!res.ok) throw new Error('Failed to create device')
  return res.json()
}

export async function updateDevice(mac, updates) {
  const res = await fetch(`/api/devices/${mac}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates)
  })
  if (!res.ok) throw new Error('Failed to update device')
  return res.json()
}

export async function deleteDevice(mac) {
  const res = await fetch(`/api/devices/${mac}`, { method: 'DELETE' })
  if (!res.ok) throw new Error('Failed to delete device')
}

// ---------- Companies ----------

export async function listCompanies() {
  const res = await fetch('/api/companies')
  if (!res.ok) throw new Error('Failed to fetch companies')
  return res.json()
}

export async function createCompany(name) {
  const res = await fetch('/api/companies', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name })
  })
  if (!res.ok) throw new Error('Failed to create company')
  return res.json()
}

// ---------- Batches ----------

export async function listBatches() {
  const res = await fetch('/api/batches')
  if (!res.ok) throw new Error('Failed to fetch batches')
  return res.json()
}

export async function createBatch(batch) {
  const res = await fetch('/api/batches', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(batch)
  })
  if (!res.ok) throw new Error('Failed to create batch')
  return res.json()
}


export async function deleteCompany(name) {
  const res = await fetch(`/api/companies/${encodeURIComponent(name)}`, { method: 'DELETE' })
  if (!res.ok) throw new Error('Failed to delete company')
}

export async function deleteBatch(number) {
  const res = await fetch(`/api/batches/${encodeURIComponent(number)}`, { method: 'DELETE' })
  if (!res.ok) throw new Error('Failed to delete batch')
}

// ---------- Timeline (stub – backend will have proper timeline later) ----------

export function getDeviceTimeline(mac) {
  // For now, the timeline is built locally in DeviceDetail.vue from notes.
  // When the backend stores structured events, this function will fetch them.
  return []
}